export default __webpack_public_path__ + "static/media/ZamZamLo.9ecf856f.png";